/**
 * Quick Actions Modal Component - Detachable Admin Module
 *
 * This component provides quick action modals for credit and plan management.
 * When extracting to a separate app, this component can be moved with minimal changes.
 */

import React from 'react';
import ChangePlanModal from './ChangePlanModal';
import AddCreditsModal from './AddCreditsModal';
import type { PlatformUser } from '../types';

interface QuickActionsModalProps {
  user: PlatformUser | null;
  action: 'addCredits' | 'changePlan' | null;
  onClose: () => void;
  onSuccess: () => void;
}

export const QuickActionsModal: React.FC<QuickActionsModalProps> = ({
  user,
  action,
  onClose,
  onSuccess,
}) => {
  if (!action || !user) return null;

  if (action === 'changePlan') {
    return (
      <ChangePlanModal
        isOpen={true}
        onClose={onClose}
        onSuccess={() => { onSuccess(); onClose(); }}
        userIdentifier={user.id || user.email}
        currentPlan={user.billing.plan_type}
        currentMonthlyAllowance={user.billing.monthly_allowance}
        userDisplayName={user.firstName || user.email}
      />
    );
  }

  return (
    <AddCreditsModal
      isOpen={action === 'addCredits'}
      userIdentifier={user.id || user.email}
      userDisplayName={user.firstName || user.email}
      currentBalance={user.billing.total_credits}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};

export default QuickActionsModal;
